// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import LectureLessonHistoryListPagingResultModel from '../../model/lecture-lesson-history-list-paging-result-model';
import LectureLessonHistoryListPagingResultDTO from '../dto/lecture-lesson-history-list-paging-result-dto';
import dtoSchema from '../schemas/lecture-lesson-history-list-paging-result-schema';
import LectureLessonHistoryListModel from '../../model/lecture-lesson-history-list-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class LectureLessonHistoryListPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<LectureLessonHistoryListPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => LectureLessonHistoryListModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: LectureLessonHistoryListModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<LectureLessonHistoryListPagingResultDTO>): LectureLessonHistoryListPagingResultModel;
  static toModel(dto: DeepPartial<LectureLessonHistoryListPagingResultDTO> | undefined | null): LectureLessonHistoryListPagingResultModel | undefined;
  static toModel(dto: DeepPartial<LectureLessonHistoryListPagingResultDTO> | undefined | null): LectureLessonHistoryListPagingResultModel | undefined {
    return dto ? new LectureLessonHistoryListPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<LectureLessonHistoryListPagingResultModel> | LectureLessonHistoryListPagingResultModel): LectureLessonHistoryListPagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as LectureLessonHistoryListPagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for LectureLessonHistoryListPagingResultModel, can not map to LectureLessonHistoryListPagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
